import ReactPaginate from 'react-paginate'
import { Box, Select as MuiSelect } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
      margin: auto;
      justify-content: space-between;
    }
  `}
`

export const PageSize = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const Select = styled(MuiSelect)`
  ${({ theme }) => css`
    height: 32px;
    border-radius: 6px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400 !important;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    padding-top: 3px;

    & .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${theme.colors.primary} !important;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${theme.colors.primary} !important;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${theme.colors.primary} !important;
    }

    & .MuiSelect-icon {
      font-size: 16px !important;
      color: #666;
    }
  `}
`

export const Paginate = styled(ReactPaginate)`
  ${({ theme }) => css`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 8px;
    align-items: center;

    li {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;
      background: ${theme.colors.lightest};
      color: ${theme.colors.secondary};
      font-size: 12px;

      &:hover {
        background: #f5f5f5;
      }

      &.selected {
        border: 1px solid ${theme.colors.primary};
        color: ${theme.colors.lightest};
        background: ${theme.colors.primary};
      }

      &.disabled {
        border-color: #ccc !important;
        background: #f9f9f9;
        color: #ccc;
        cursor: not-allowed;
      }

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: inherit;
      }

      &.break {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        color: #666;
        border: none;
      }

      &.previous,
      &.next {
        border: 1px solid ${theme.colors.primary};
      }
    }
  `}
`
